/*!
 * hoverIntent r7 // 2013.03.11 // jQuery 1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 *
 * You may use hoverIntent under the terms of the MIT license.
 * Copyright 2007, 2013 Brian Cherne
 */
(function (e) { e.fn.hoverIntent = function (t, n, r) { var i = { interval: 100, sensitivity: 7, timeout: 0 }; if (typeof t === "object") { i = e.extend(i, t) } else if (e.isFunction(n)) { i = e.extend(i, { over: t, out: n, selector: r }) } else { i = e.extend(i, { over: t, out: t, selector: n }) } var s, o, u, a; var f = function (e) { s = e.pageX; o = e.pageY }; var l = function (t, n) { n.hoverIntent_t = clearTimeout(n.hoverIntent_t); if (Math.abs(u - s) + Math.abs(a - o) < i.sensitivity) { e(n).off("mousemove.hoverIntent", f); n.hoverIntent_s = 1; return i.over.apply(n, [t]) } else { u = s; a = o; n.hoverIntent_t = setTimeout(function () { l(t, n) }, i.interval) } }; var c = function (e, t) { t.hoverIntent_t = clearTimeout(t.hoverIntent_t); t.hoverIntent_s = 0; return i.out.apply(t, [e]) }; var h = function (t) { var n = jQuery.extend({}, t); var r = this; if (r.hoverIntent_t) { r.hoverIntent_t = clearTimeout(r.hoverIntent_t) } if (t.type == "mouseenter") { u = n.pageX; a = n.pageY; e(r).on("mousemove.hoverIntent", f); if (r.hoverIntent_s != 1) { r.hoverIntent_t = setTimeout(function () { l(n, r) }, i.interval) } } else { e(r).off("mousemove.hoverIntent", f); if (r.hoverIntent_s == 1) { r.hoverIntent_t = setTimeout(function () { c(n, r) }, i.timeout) } } }; return this.on({ "mouseenter.hoverIntent": h, "mouseleave.hoverIntent": h }, i.selector) } })(jQuery)
var dialogBoxes = (function () {
	jQuery.fn.initMainDialog = function (opts) {
		var curr = this;
		var settings = {
			width: 300,
			resizable: false,
			autoOpen: false,
			extraOpen: function (curr) { },
			extraClose: function (curr) { },
			open: function () {
				jQuery(".background-dim").css({
					opacity: 0,
					filter: "alpha(opacity=0)",
					background: "#000",
					display: "block"
				}).animate({ opacity: 0.7 }, { duration: 200 });
				settings.extraOpen(curr);
			},
			close: function () {
				jQuery(".background-dim").fadeOut(200);
				settings.extraClose(curr);
			}
		};
		jQuery.extend(settings, opts);
		curr.dialog(settings);
		return curr;
	};
	jQuery.fn.initMiniDialog = function (opts) {
		var curr = this;
		var settings = {
			onAfterShow: function () { },
			show: {
				effect: "fade", duration: 200, complete: function () {
					var func = settings.onAfterShow;
					func();
				}
			},
			hide: { effect: "fade", duration: 200 },
			minHeight: 20,
			width: 150,
			resizable: false,
			autoOpen: false,
			draggable: false,
			create: function () {
				curr.addClass("miniDialog");
			}
		};
		jQuery.extend(settings, opts);
		curr.dialog(settings);
		return curr;
	}
	jQuery.fn.openMiniDialog = function (eventOrXPos, YPos, hcentered) {
		if (typeof hcentered == "undefined") hcentered = true;
		var curr = this;
		var width = this.dialog("option", "width");
		if (typeof eventOrXPos == "object") {
			var mousex = parseInt(eventOrXPos.pageX, 10) - parseInt(jQuery(window).scrollLeft(), 10);
			var posx = (hcentered) ? (mousex - parseInt((width / 2), 10)) : mousex;
			var posy = parseInt(eventOrXPos.pageY, 10) - parseInt(jQuery(window).scrollTop(), 10) - 40;
		} else if ((typeof eventOrXPos == "number") && (typeof YPos == "number")) {
			var posx = (hcentered) ? (eventOrXPos - parseInt((width / 2), 10)) : eventOrXPos;
			var posy = YPos - 40;
		}
		curr.dialog("option", "position", [posx, posy]);
		curr.dialog("open").delay(2000).fadeOut(function () {
			if (curr.dialog("isOpen")) curr.dialog("close");
		});
		return curr;
	}
})();

(function ($) {
	function addBlocker ($el) {
		if ($el.length) {
			$el.addClass("section-blocker").children().addClass("section-blocker--faded");
			$el.append('<div class="section-blocker--loader"></div>');
		}
	}
	function removeBlocker ($el) {
		if ($el.length) {
			$el.removeClass("section-blocker").children().removeClass("section-blocker--faded");
			$el.children(".section-blocker--loader").remove();
		}
	}
	function handleSubmission (e, opts, cb) {
		e.preventDefault();
		var settings = {
			blockFormBeforeSend: true,
			unblockFormOnError: true,
			unblockFormOnSuccess: true,
			replaceFormOnError: true,
			replaceFormOnSuccess: true,
			includePjaxBlockers: true,
			beforeSend: $.noop,
			callback: $.noop
		};
		var form = this;
		var $form = $(form);
		var rawSettings = $form.attr("data-ajax-submit");
		if (rawSettings) {
			$.extend(settings, JSON.parse(rawSettings));
		}
		if (opts) {
			$.extend(settings, opts);
		}
		if (cb) {
			settings.callback = cb;
		}
		if (!$.data(form, "tvfd.ajaxFormSubmitting")) {
			$.data(form, "tvfd.ajaxFormSubmitting", true);
			if (settings.blockFormBeforeSend) {
				addBlocker($form);
			}
			if (settings.includePjaxBlockers && settings.pjaxFragments && settings.pjaxFragments.length) {
				for (var i = 0, len = settings.pjaxFragments.length; i < len; ++i) {
					var key = JSON.stringify(settings.pjaxFragments[i]);
					addBlocker($("[data-pjax-fragment='" + key + "']"));
				}
			}
			settings.beforeSend.call(form);
			var ajaxOpts = {
				data: $form.serialize(),
				dataType: "json",
				type: $form.attr("method"),
				url: $form.attr("action"),
				error: function (jqXhr, textStatus, errorThrown) {
					$.removeData(form, "tvfd.ajaxFormSubmitting");
					if (settings.blockFormBeforeSend && settings.unblockFormOnError) {
						removeBlocker($form);
					}
					if (settings.includePjaxBlockers && settings.pjaxFragments && settings.pjaxFragments.length) {
						for (var i = 0, len = settings.pjaxFragments.length; i < len; ++i) {
							var key = JSON.stringify(settings.pjaxFragments[i]);
							removeBlocker($("[data-pjax-fragment='" + key + "']"));
						}
					}
					return settings.callback.call(form, window.tvfd.ajaxSubmit.HTTP_ERROR, {
						jqXhr: jqXhr,
						textStatus: textStatus,
						errorThrown: errorThrown
					});
				},
				success: function (data, textStatus, jqXhr) {
					$.removeData(form, "tvfd.ajaxFormSubmitting");
					var exitCode = window.tvfd.ajaxSubmit.UNEXPECTED_RESPONSE;
					if (data.hasOwnProperty("errorCount") && (typeof data.errorCount === "number") && data.hasOwnProperty("form") && (typeof data.form === "string")) {
						if (data.errorCount) {
							exitCode = window.tvfd.ajaxSubmit.VALIDATION_ERROR;
							if (settings.blockFormBeforeSend && settings.unblockFormOnError) {
								removeBlocker($form);
							}
							if (settings.replaceFormOnError) {
								var $formReplacement = $(data.form);
								$form.replaceWith($formReplacement);
								form = $formReplacement[0];
							}
						} else {
							if (settings.pjaxFragments) {
								for (var i = 0, len = settings.pjaxFragments.length; i < len; ++i) {
									var key = JSON.stringify(settings.pjaxFragments[i]);
									$("[data-pjax-fragment='" + key + "']").html(data.pjaxFragments[i]);
								}
							}
							if (settings.blockFormBeforeSend && settings.unblockFormOnSuccess) {
								removeBlocker($form);
							}
							if (settings.replaceFormOnSuccess) {
								var $formReplacement = $(data.form);
								$form.replaceWith($formReplacement);
								form = $formReplacement[0];
							}
							exitCode = window.tvfd.ajaxSubmit.SUCCESS;
						}
					} else {
						if (settings.blockFormBeforeSend && settings.unblockFormOnError) {
							removeBlocker($form);
						}
					}
					if (settings.includePjaxBlockers && settings.pjaxFragments && settings.pjaxFragments.length) {
						for (var i = 0, len = settings.pjaxFragments.length; i < len; ++i) {
							var key = JSON.stringify(settings.pjaxFragments[i]);
							removeBlocker($("[data-pjax-fragment='" + key + "']"));
						}
					}
					return settings.callback.call(form, exitCode, {
						data: data,
						textStatus: textStatus,
						jqXhr: jqXhr
					});
				}
			};
			if (settings.pjaxFragments && settings.pjaxFragments.length) {
				ajaxOpts.headers = {
					"X-Pjax-Fragments": JSON.stringify(settings.pjaxFragments)
				};
			}
			$.ajax(ajaxOpts);
		}
	}

	window.tvfd = window.tvfd || {};
	window.tvfd.ajaxSubmit = window.tvfd.ajaxSubmit || {};
	window.tvfd.ajaxSubmit.SUCCESS = 0;
	window.tvfd.ajaxSubmit.HTTP_ERROR = 1;
	window.tvfd.ajaxSubmit.VALIDATION_ERROR = 2;
	window.tvfd.ajaxSubmit.UNEXPECTED_RESPONSE = 4;
	window.tvfd.ajaxSubmit.handleSubmission = handleSubmission;
	window.tvfd.ajaxSubmit.addBlocker = addBlocker;
	window.tvfd.ajaxSubmit.removeBlocker = removeBlocker;
	$(document).on("submit", "form[data-ajax-submit]", handleSubmission);
})(jQuery);

const createRecaptchaToken = () => grecaptcha.execute(window.JS_VARS.recaptchaV3SiteKey, {action:'validate_captcha'});

jQuery(document).ready(function ($) {
	window.dataLayer = window.dataLayer || [];
	var baseHref = jQuery("base").attr("href");
	(function () {
		var advertSizes = {
			'medium-rectangle': [300, 250],
			'square-popup': [250, 250],
			'vertical-rectangle': [240, 400],
			'large-rectangle': [336, 280],
			'rectangle': [180, 150],
			'3-1-rectangle': [300, 100],
			'pop-under': [720, 300],
			'full-banner': [468, 60],
			'half-banner': [234, 60],
			'micro-bar': [88, 31],
			'button-1': [120, 90],
			'button-2': [120, 60],
			'vertical-banner': [120, 240],
			'square-button': [125, 125],
			'leaderboard': [728, 90],
			'wide-skyscraper': [160, 600],
			'skyscraper': [120, 600],
			'half-page-ad': [300, 600]
		};
		if (window.JS_VARS !== undefined) {
			var adverts = window.JS_VARS.Adverts;
			for (var size in advertSizes) {
				if (advertSizes.hasOwnProperty(size)) {
					var width = advertSizes[size][0];
					var height = advertSizes[size][1];
					if (adverts && adverts.hasOwnProperty(size)) {
						var advert = adverts[size];
						$("[data-iaiadsize='" + advert.size + "']").html(
							"<a "
							+ "class='ga_track iaiad--advert iaiad--advert__js' "
							+ "data-gaeventcategory='Custom Advert' "
							+ "data-gaeventaction='click'"
							+ "data-gaeventlabel='" + advert.size + " : " + advert.id + "' "
							+ "data-iaiadid='" + advert.id + "' "
							+ "href='" + advert.link + "' "
							+ "target='_blank'"
							+ "style='width:" + width + "px;height:" + height + "px;'"
							+ ">"
							+ "<img "
							+ "src='" + advert.image + "' "
							+ "width='" + width + "' "
							+ "height='" + height + "' "
							+ " />"
							+ "</a>"
						);
					} else {
						var iframe = document.createElement('iframe');
						$("[data-iaiadsize='" + size + "']").each(function () {
							var $this = $(this);
							var $iframe = $("<iframe />");
							$iframe.width(width).height(height);
							$iframe.attr('frameBorder', '0').addClass('iaiad--advert');
							var content = [
								'<html style="padding:0;margin:0;border:0;width:' + width + 'px;height:' + height + 'px;overflow:hidden;font-size:0;line-height:0;">',
								'<head>',
								'</head>',
								'<body style="padding:0;margin:0;border:0;width:' + width + 'px;height:' + height + 'px;overflow:hidden;font-size:0;line-height:0;">',
								'<div>',
								'<script id="mNCC" type="text/javascript">  medianet_width="' + width + '";  medianet_height= "' + height + '";  medianet_crid="524740567";  </script>',
								'<script id="mNSC" src="https://contextual.media.net/nmedianet.js?cid=8CUW4403A" type="text/javascript"></script>',
								'</div>',
								'</body>',
								'</html>'
							].join();
							var iframe = $iframe[0];
							$this.append($iframe);
							iframe.contentWindow.contents = content;
							iframe.src = 'javascript:window["contents"]';
						});
					}
				}
			}

			var $window = $(window);
			var impressionsDone = {};
			function testImpressions () {
				var windowTop = $window.scrollTop();
				var windowBottom = windowTop + $window.height();
				var $adverts = $(".iaiad--advert__js");
				$adverts.each(function () {
					var $this = $(this);
					var top = $this.offset().top;
					var bottom = top + $this.height();
					if (bottom > windowTop && top < windowBottom) {
						var id = parseInt($this.attr('data-iaiadid'), 10);
						var size = $this.parent().attr('data-iaiadsize');
						if (!impressionsDone[id]) {
							impressionsDone[id] = true;
							window.dataLayer.push({
								'event': 'impression',
								'event_category': 'Custom Advert',
								'event_label': size + " : " + id
							});
						}
					}
				});
			}
			setInterval(testImpressions, 200);
		}
		$('.full-access-first--close-popup__js').click(function (e) {
			e.preventDefault();
			$('.full-access--first').addClass('full-access__hidden');
		});
		$('.full-access-second--close-popup__js').click(function (e) {
			e.preventDefault();
			$('.full-access--second').addClass('full-access__hidden');
		});
		$('.full-access--sign-up').click(function (e) {
			$('.full-access--first').addClass('full-access__hidden');
			$('.full-access--second').addClass('full-access__hidden');
		});
		$('.search-close-main').click(function (e) {
			$("input[type=text]").val("");
		});
	})();

	if (jQuery("#js-login").length) {
		jQuery("#js-login").removeClass('js-login-no-js');
		jQuery("#js-login").initMainDialog({
			width: 600,
			dialogClass: "js-login-dialog",
			extraClose: function (curr) {
				jQuery("#js-login input").val("");
				jQuery("#js-login .js-login-error-messages").addClass("hidden");
				jQuery("#js-login .ajax-loader").addClass("hidden");
			}
		});
	}
	(function () {
		var justActivatedAccountPopup;
		if (justActivatedAccountPopup = document.getElementById("JustActivatedAccountPopup")) {
			var $justActivatedAccountPopup = $(justActivatedAccountPopup);
			$justActivatedAccountPopup.initMainDialog({
				width: 300,
				dialogClass: "just-activated-account-popup--container"
			});
			$justActivatedAccountPopup.dialog('open');
		}
	})();
	(function ($articleLimitPopups) {
		if ($articleLimitPopups.length) {
			$articleLimitPopups.each(function () {
				$(this).initMainDialog({
					width: 600,
					dialogClass: "article-limit-popup--dialog"
				});
			});
		}
	})($(".article-limit-popup"));
	var $document = $(document);
	const createRecaptchaToken = async () => await grecaptcha.execute(window.JS_VARS.recaptchaV3SiteKey, {action:'validate_captcha'});
	$document.on("submit", "#UserLoginForm_getUserLoginForm", function (e) {
		window.tvfd.ajaxSubmit.handleSubmission.call(this, e, {
			unblockFormOnSuccess: false,
			replaceFormOnSuccess: false
		}, function (err) {
			if (!err) {
				if (window.location.search) {
					var parts = window.location.search.split(/[\?&]/g);
					for (var i = 0, len = parts.length; i < len; ++i) {
						var p = parts[i].split("=");
						var key = p[0];
						var value = p[1];
						if ((key === "BackURL") && value && (value = decodeURIComponent(value)) && (value.indexOf(baseHref) === 0)) {
							window.location.href = value;
							return;
						}
					}
				}
				window.location.reload(true);
			}
		});
	});
	$document.on("submit", "#VideoCommentForm_VideoCommentForm", function (e) {
		window.tvfd.ajaxSubmit.handleSubmission.call(this, e, {
			pjaxFragments: [["VideoController.getApprovedVideoComments", [window.JS_VARS.VideoID]]]
		}, function (err) {
			$("#comments-accordion").accordion("refresh");
			if (!err) {
				$("html,body").animate({
					scrollTop: $("#CommentsList").offset().top
				});
			}
		});
	});
	async function loadRecaptchaScriptWhenNeeded() {
		return new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = 'iaiwidgets/public/js/recaptchaScript.js';
			script.async = true;
			script.onload = () => {
				resolve();
			};
			script.onerror = () => {
				reject(new Error("Failed to load reCAPTCHA script"));
			};
			document.body.appendChild(script);
		});
	}
	$document.on("submit", "#ArticleCommentForm_CommentForm", async function (e) {
		e.preventDefault();
		try {
			await loadRecaptchaScriptWhenNeeded();
			await window.loadRecaptchaScript();
			const token = await window.executeRecaptcha();
			document.querySelector("#ArticleCommentForm_CommentForm_RecaptchaToken").value = token;
		window.tvfd.ajaxSubmit.handleSubmission.call(this, e, {
			pjaxFragments: [["ArticlePage_Controller.getApprovedCommentsPjax", [window.JS_VARS.ArticleID]]]
		}, function (err) {
			if (!err) {
				$("html,body").animate({
					scrollTop: $("#CommentsList").offset().top
				});
			}
		});
		} catch (error) {
			console.error("Error during reCAPTCHA execution:", error);
			$('.recaptcha-error').html("Recaptcha could not be verified.");
			$('.recaptcha-error').css({ 'display': 'block', 'color': 'red' });
		}
	});

	/**
	 * Newsletter sign-up
	 */

	var nldefault = "Enter your email";
	jQuery("#Form_SignUpForm_UserEmail").focus(function () {
		if (jQuery(this).val() == nldefault) {
			jQuery(this).val("");
		}
	});
	jQuery("#Form_SignUpForm_UserEmail").blur(function () {
		if (jQuery(this).val() == "") {
			jQuery(this).val(nldefault);
		}
	});
	$(document).on("change", "form.submit-on-change", function (e) {
		var $this = $(this);
		setTimeout(function () {
			$this.submit();
		}, 20);
	});
	$("body").on("click", ".js-login-link", function (e) {
		e.preventDefault();
		jQuery("#js-login").dialog("open");
	});

	// Handle the scrolling for the 'most viewed' and 'top rated' sections on the featured videos page.

	if (jQuery(".extra-vids-left-arrow").length) {
		jQuery(".extra-vids-left-arrow").click(function () {
			var videos = jQuery(this).parent().find(".extra-vid");
			var separators = jQuery(this).parent().find(".separator");
			var scrollthis = jQuery(this).parent().find(".extra-vids-videos-inner");
			var scrollwidth = videos.width() + separators.width();
			var currmargin = parseInt(scrollthis.css("margin-left"));
			if (currmargin < 0) scrollthis.stop(false, true).animate({ "margin-left": "+=" + scrollwidth }, 400);
		})
	}
	if (jQuery(".extra-vids-right-arrow").length) {
		jQuery(".extra-vids-right-arrow").click(function () {
			var videos = jQuery(this).parent().find(".extra-vid");
			var separators = jQuery(this).parent().find(".separator");
			var scrollthis = jQuery(this).parent().find(".extra-vids-videos-inner");
			var scrollwidth = videos.width() + separators.width();
			var currmargin = parseInt(scrollthis.css("margin-left"));
			var maxscrollwidth = scrollwidth * (videos.length) - 2 * scrollwidth;
			if (currmargin > (-1 * maxscrollwidth)) scrollthis.stop(false, true).animate({ "margin-left": "-=" + scrollwidth }, 400);
		})
	}

	jQuery.fn.collapseExpander = function () {
		jQuery(this).find(".expand-collapse-title").addClass("expand-collapse-arrow-closed").removeClass("expand-collapse-arrow-open");
		jQuery(this).find(".expand-collapse-content-container-outer").slideUp(400);
		jQuery(this).removeClass("expanded").addClass("collapsed");
	}
	jQuery.fn.expandExpander = function () {
		jQuery(this).find(".expand-collapse-title").addClass("expand-collapse-arrow-open").removeClass("expand-collapse-arrow-closed");
		jQuery(this).find(".expand-collapse-content-container-outer").slideDown(400);
		jQuery(this).removeClass("collapsed").addClass("expanded");
	}
	jQuery.each(jQuery(".expand-collapse-container"), function () {
		jQuery(this).collapseExpander();
	});
	jQuery(".expand-collapse-title").click(function () {
		var parent = jQuery(this).closest(".expand-collapse-container");
		if (parent.hasClass("expanded")) {
			parent.collapseExpander();
		} else {
			parent.expandExpander();
		}
	});

	(function(h,o,t,j,a,r){
		h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
		h._hjSettings={hjid:window.JS_VARS.hotjarSiteKey,hjsv:6};
		a=o.getElementsByTagName('head')[0];
		r=o.createElement('script');r.async=1;
		r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
		a.appendChild(r);
	})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');

	jQuery("#Comments_Cont").on("click", ".ReportSpam a.delete", function (e) {
		e.preventDefault();
		var _this = jQuery(this);
		var form = _this.parent().find("form");
		var controllerClass = form.find("input[name=ControllerClass]").val();
		var data = form.serialize();
		data += '&action=delete';
		jQuery.post(controllerClass + "/SpamReportForm", data, function (res) {
			var message = "error";
			if (res.status == "success") {
				_this.parent().parent().remove();
			} else {
				_this.parent().html(message);
			}

		}, "json");
	});
	$(document).on('click', '.edit-poster-prefix__js', function(e) {
		e.preventDefault();
		const inputElementId = $(this).attr('data-commentid');
		const inputElement = $('input[data-inputfieldid=' + inputElementId + ']');
		if ($(this).text() === 'Edit') {
			inputElement.removeClass('hidden');
			$(this).text('Cancel');
		} else {
			inputElement.addClass('hidden');
			$(this).text('Edit');
		}
	});
	$(document).on('input', '.poster-prefix-input__js', function(e) {
		let commentId = $(this).attr('data-inputfieldid');
		if ($(this).val().length) {
			$('.edit-poster-prefix__js[data-commentid='+ commentId +']').text('Save').addClass('save-poster-prefix__js').removeClass('edit-poster-prefix__js');
		} else {
			$('.save-poster-prefix__js[data-commentid='+ commentId +']').text('Cancel').removeClass('save-poster-prefix__js').addClass('edit-poster-prefix__js');
		}
	});
	$(document).on('click', '.save-poster-prefix__js', function(event) {
		event.preventDefault();
		const elementId = $(this).attr('data-commentid');
		const posterPrefixInputElement = $('input[data-inputfieldid=' + elementId + ']');
		const form = $(this).parent().find("form");
		const controllerClass = form.find("input[name=ControllerClass]").val();
		let data = form.serialize();
		const posterPrefixValue = posterPrefixInputElement.val();
		data += '&action=prefix-change&prefix-value=' + posterPrefixValue;
		$.ajax({
			url: controllerClass + '/SpamReportForm',
			data: data,
			type: "POST",
			success: function (response) {
				const res = JSON.parse(response);
				const responseMessageElement = $('.poster-prefix-update-status__js[data-id='+ elementId +']');
				if (res.status === 'success') {
					responseMessageElement.html('Poster prefix Updated successfully').addClass('success');
					$('.article-comment-poster-prefix-name__js[data-id='+ elementId +']').html(posterPrefixValue);
				} else {
					responseMessageElement.html('Something went wrong! please try again later.').addClass('error');
				}
				$('.save-poster-prefix__js[data-commentid='+ elementId +']').text('Edit').removeClass('save-poster-prefix__js').addClass('edit-poster-prefix__js');
				responseMessageElement.removeClass('hidden');
				posterPrefixInputElement.addClass('hidden');
				setTimeout(function(){
					responseMessageElement.fadeOut('slow');
				}, 3000);
			}
		});
	});
	jQuery(".selectAllOnHover").click(function () {
		var curr = jQuery(this);
		curr.select();

		// Work around Chrome's little problem
		curr.mouseup(function () {
			// Prevent further mouseup intervention
			curr.unbind("mouseup");
			return false;
		});
	});

	var eventsForGA = [];
	eventsForGA.push([".body-join-the-iai-mailing-list #Form_MailListSignupForm", 'submit', "Support iai - join mailing list", "Submit", "NewsletterSignup-Main-Bottom"]);
	eventsForGA.push([".ArticlePage #SignUpForm_getForm", 'submit', "IAI News Article Page", "Submit", "NewsletterSignup-Sidebar-Bottom"]);
	eventsForGA.push([".ArticleCategoryPage #SignUpForm_getForm", 'submit', "IAI News Home", "Submit", "NewsletterSignup-Sidebar-Bottom"]);
	eventsForGA.push([".body-articles #SignUpForm_getForm", 'submit', "Support iai - join mailing list", "Submit", "NewsletterSignup-Main-Bottom"]);
	eventsForGA.push([".body-VideoController #SignUpForm_getForm", 'submit', "Individual video page", "Submit", "NewsletterSignup-Sidebar-Right"]);
	eventsForGA.push([".body-home #SignUpForm_getForm", 'submit', "Homepage", "Submit", "NewsletterSignup-Main-Top"]);
	eventsForGA.push(["#Form_SignUpForm", 'submit', "Header", "Submit", "NewsletterSignup"]);
	eventsForGA.push([".news-tile-item-video-bullet a", 'click', "Referral to IAI TV", "Link", "Related Article"]);
	eventsForGA.push([".article-latest-videos-list a", 'click', "Referral to IAI TV", "Link", "This week on iai tv widget"]);
	eventsForGA.push([".article-tile-list-debates a, article-tile-list-talks a", 'click', "Referral to IAI TV", "Link", "Most Viewed widget"]);
	if (window.location.pathname.indexOf('/articles') != -1) {
		eventsForGA.push([".header-main-menu li:first-child a", 'click', "Referral to IAI TV", "Link", "Main Menu"]);
		eventsForGA.push([".footer-left a", 'click', "Referral to IAI TV", "Link", "Footer Logo"]);
		eventsForGA.push([".header-logo a", 'click', "Referral to IAI TV", "Link", "Header Logo"]);
	} else {
		eventsForGA.push([".header-main-menu li:nth-child(2) a", 'click', "Referral to IAI NEWS", "Link", "Main Menu"]);
	}
	eventsForGA.push([".global-content a", 'click', "Referral to HTLGI", "Link", "Top Banner IAI TV", "howthelightgetsin"]);
	eventsForGA.push([".article-top-images-container a", 'click', "Referral to HTLGI", "Link", "Top Banner IAI NEWS", "howthelightgetsin"]);
	eventsForGA.push([".header-main-menu li:nth-child(3) a", 'click', "Referral to HTLGI", "Link", "Main Menu", "howthelightgetsin"]);
	for (var i = 0; i < eventsForGA.length; i++) {
		var a = eventsForGA[i];
		attachEvent(a[0], a[1], a[2], a[3], a[4], a[5]);
	}
	function attachEvent (selector, trigger, category, action, label, destination) {
		if (jQuery(selector).length) {
			label += ' | Source: ' + document.URL;
			if (trigger == "click") {
				jQuery(selector).on("click", function (e) {
					checkDestination(this, destination);
					window.dataLayer.push({
						'event': eventAction,
						'event_category': category,
						'event_label': label
					});
				});
			} else if (trigger = "submit") {
				jQuery(selector).on("submit", function (e) {
					window.dataLayer.push({
						'event': eventAction,
						'event_category': category,
						'event_label': label
					});
				});
			}
		}
	}
	function checkDestination (el, destination) {
		//check destination if defined
		if (destination) {
			if (typeof el.href != 'undefined') {
				if (el.href.indexOf(destination) == -1) {
					return false;
				} else {
					return true;
				}
			}
		}
	}
	(function () {
		function hideDialogBox () {
			$(this).dialog('close');
		}
		function hideDialogBoxes () {
			$(":ui-dialog:visible").each(hideDialogBox);
		}
		$(document).on("click", ".background-dim", hideDialogBoxes);
	})();

	/**
	 * Enable event-tracking on selected elements by inserting a 'ga_track' class.
	 * @todo This block is horribly messy. Tidy up at some point.
	 */
	(function ($) {
		/**
		 * STRING class_begins(OBJECT the_element, STRING the_string)
		 * If the_element has a class that begins with the_string, class_begins returns the remainder of that class.
		 * If the_element does not have a class that begins with the_string, class_begins returns false.
		 */
		function class_begins (the_element, the_string) {
			var classes = the_element.className.split(" ");
			for (var i = 0; i < classes.length; i++) {
				var this_class = classes[i];
				if (this_class.indexOf(the_string) == 0) {
					var j = classes[i];
					var last = j.substring(the_string.length);
					return last;
				};
			}
			return false;
		}
		function getCategory (el) {
			var EL = $(el);
			var val = "";
			if (typeof EL.attr("data-gaeventcategory") !== "undefined") {
				val = EL.attr("data-gaeventcategory");
			} else {
				val = class_begins(el, 'ga_category_');
			}
			return val ? val : 'undefined';
		}
		function getAction (el) {
			var EL = $(el);
			var val = "";
			if (typeof EL.attr("data-gaeventaction") !== "undefined") {
				val = EL.attr("data-gaeventaction");
			} else {
				val = class_begins(el, 'ga_action_');
			}
			return val ? val : 'Click';
		}
		function getNonInteract (el) {
			var EL = $(el);
			if (typeof EL.attr("data-gaeventnoninteract") !== "undefined") {
				return (EL.attr("data-gaeventnoninteract") != 'no');
			} else {
				return Boolean(class_begins(el, 'ga_nonInteract_'));
			}
		}
		function getLabel (el) {
			var EL = $(el);
			var val = "";
			if (typeof EL.attr("data-gaeventlabel") !== "undefined") {
				val = EL.attr("data-gaeventlabel");
			} else {
				val = class_begins(el, 'ga_label_');
			}
			if (!val) {
				if (typeof EL.attr('href') == 'undefined') {
					val = "'" + el.nodeName.toUpperCase() + "' element at " + window.location;
				} else {
					val = "Link to: " + EL.attr('href');
				}
			}
			return val;
		}

		/**
		 * Enable event tracking on all <a> elements with a ga_track class.
		 * The element to be event tracked can have three additional event tracking related classes:
		 *  - ga_category_<string>
		 *  - ga_action_<string>
		 *  - ga_label_<string>
		 * ...where <string> is any valid string.
		 */
		$(document).on("click", ".ga_track,[data-gaeventtrack]", function (e) {
			var curr = this;
			var $curr = $(curr);
			var destination = $(this).attr('href');
			var newWindow = ($(this).attr("target") == "_blank");
			if (typeof destination === "string" && destination.length && !newWindow && !$curr.hasClass("no-link")) {
				e.preventDefault();
			}
			var category = getCategory(curr);
			var action = getAction(curr);
			var nonInteract = getNonInteract(curr);
			var label = getLabel(curr);
			window.dataLayer.push({
				'event': action,
				'event_category': category,
				'event_label': label
			});
			if (!$curr.hasClass("no-link")) {
				if (typeof destination === "string" && destination.length && !newWindow) {
					setTimeout(function () {
						window.location.href = destination;
					}, 100);
				}
			}
		});
	})(jQuery);

	(function ($) {
		$(document).on("click", ".cookie-notification--close__js", function (e) {
			e.preventDefault();
			document.cookie = 'agreedtocookies=yes; expires=Fri, 3 Aug 2020 00:00:00 UTC; domain=.iai.tv; path=/';
			$(this).closest(".cookie-notification").slideUp();
		});
	})(jQuery);

	(function ($) {
		// hacked support for browsers that don't support the placeholder attribute (looking at you IE)
		var i = document.createElement("input");
		if (!("placeholder" in i)) {
			$('input[placeholder]').focus(function () {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
					input.removeClass('placeholder');
				}
			}).blur(function () {
				var input = $(this);
				if (input.val() == '' || input.val() == input.attr('placeholder')) {
					input.addClass('placeholder');
					input.val(input.attr('placeholder'));
				}
			}).blur();
			$('input[placeholder]').parents('form').submit(function () {
				$(this).find('[placeholder]').each(function () {
					var input = $(this);
					if (input.val() == input.attr('placeholder')) {
						input.val('');
					}
				})
			});
		}
	})(jQuery);

	// Header mobile menu
	(function () {
		// Secondary menu
		$document.on('click', '.iaie-mobile-menu', function (e) {
			e.preventDefault();
			$('.iaie-header--menu--bottom').slideToggle();
		});

		// Primary menu
		$document.on('click', '.iaie-navbar--top-section--menu-link', function (e) {
			e.preventDefault();
			var $menu = $('.iaie-navbar--top-section__menu');
			$menu.toggle();
		});
	})();

	(function ($) {
		var article = null;
		function firstBreakpoint () {
			var accessParam = window.location.href.split('access=A')[1];
			if (accessParam) {
				return;
			}
			window.dataLayer.push({
				'event': 'popup',
				'event_category': 'Popup',
				'event_label': 'ArticlesFirstBreakpoint-PopupAppear',
			});
			jQuery(".article-limit-popup--first").dialog("option", "minHeight", 0);
			jQuery(".article-limit-popup--first").dialog("open");
		}
		function secondBreakpoint () {
			var accessParam = window.location.href.split('access=A')[1];
			if (accessParam) {
				return;
			}
			window.dataLayer.push({
				'event': 'popup',
				'event_category': 'Popup',
				'event_label': 'ArticlesSecondBreakpoint-PopupAppear',
			});
			jQuery(".article-limit-popup--second").dialog("option", "minHeight", 0);
			jQuery(".article-limit-popup--second").dialog("open");
		}
		function finalBreakpoint () {
			return;
			var accessParam = window.location.href.split('access=A')[1];
			if (accessParam) {
				return;
			}
			var exceeded = localStorage.getItem("TotalArticles.BreakpointsExceeded");
			if (exceeded) {
				try {
					exceeded = JSON.parse(data);
				} catch (e) {
					exceeded = {};
				}
			} else {
				exceeded = {};
			}
			if (!exceeded.hasOwnProperty("finalBreakpoint")) {
				window.dataLayer.push({ 
					'event': 'popup',
					'event_category': 'Popup',
						'event_label': 'ArticlesFinalBreakpoint-PopupAppear',
				});
				jQuery(".article-limit-popup--final").dialog("option", "minHeight", 0);
				jQuery(".article-limit-popup--final").dialog("open");
			}
			$(".article-post-content--full").remove();
			$(".article-post-content--full-access-summary").removeClass("article-post-content--full-access-summary_hidden");
			$(".article-plus-content").removeClass("article-plus-content__hidden");
		}

		var breakpoints = [{
			id: "finalBreakpoint",
			num: 2,
			handler: finalBreakpoint
		}, {
			id: "firstBreakpoint",
			num: 1,
			handler: firstBreakpoint
		}];

		function getExceededBreakpoint (data) {
			var total = 0;
			if (!data) {
				data = localStorage.getItem("TotalArticles.Data");
				var parseData = JSON.parse(data);
				if (parseData != null) {
					var totalData = Object.values(parseData).length;
				}
				if (data) {
					try {
						data = JSON.parse(data);
					} catch (e) {
						data = {};
					}
				} else {
					data = {};
				}
			}
			for (var id in data) {
				if (data.hasOwnProperty(id)) {
					total++; 1
				}
			}
			for (var i = 0, len = breakpoints.length; i < len; ++i) {
				if (total >= breakpoints[i].num) {
					return i;
				}
			}
			return null;
		}

		function check () {
			var now = (new Date()).getTime();
			var dateAdded = localStorage.getItem("TotalArticles.DateAdded");
			if (!dateAdded) {
				localStorage.setItem("TotalArticles.DateAdded", now);
				dateAdded = now;
				$(".article--popup").removeClass('hidden');
				setTimeout(function() { $(".article--popup").fadeOut(1500); }, 10000)
			} else {
				dateAdded = parseInt(dateAdded, 10);
			}
			if ((now - dateAdded) > 30 * 24 * 60 * 60 * 1000 /* 30 days */) {
				localStorage.setItem("TotalArticles.DateAdded", now);
				localStorage.removeItem("TotalArticles.Data");
				localStorage.removeItem("TotalArticles.BreakpointsExceeded");
			}
			var exceededBreakpoint = getExceededBreakpoint();
			if (exceededBreakpoint !== null) {
				var breakpointsDone = localStorage.getItem("TotalArticles.BreakpointsExceeded");
				if (breakpointsDone) {
					try {
						breakpointsDone = JSON.parse(breakpointsDone);
					} catch (e) {
						breakpointsDone = null;
					}
				} else {
					breakpointsDone = {};
				}
				if (
					(breakpoints[exceededBreakpoint].id === "finalBreakpoint")
					|| !breakpointsDone.hasOwnProperty(breakpoints[exceededBreakpoint].id)
				) {
					breakpointsDone[breakpoints[exceededBreakpoint].id] = breakpoints[exceededBreakpoint].id;
					localStorage.setItem(
						"TotalArticles.BreakpointsExceeded",
						JSON.stringify(breakpointsDone)
					);
					breakpoints[exceededBreakpoint].handler();
				}
			}
			var data = localStorage.getItem("TotalArticles.Data");
			if (data) {
				try {
					data = JSON.parse(data);
				} catch (e) {
					data = {};
				}
			} else {
				data = {};
			}
			if (!data.hasOwnProperty(article)) {
				data[article] = 1;
			}
			localStorage.setItem("TotalArticles.Data", JSON.stringify(data));
		}
		if ((typeof JS_VARS !== "undefined") && JS_VARS && JS_VARS.Controller && JS_VARS.Controller.hasOwnProperty('ArticlePage_Controller') && JS_VARS.hasOwnProperty('ArticleID') && !JS_VARS.IsLoggedIn && (typeof window.localStorage !== "undefined") && (typeof window.JSON !== "undefined")) {
			article = JS_VARS.ArticleID;
			check();
		}
	})(jQuery);

	(function ($) {
		$(window).scroll(function () {
			if ($(window).scrollTop() > 100) {
				$(".sticky-navbar").addClass("js-active");
			}
			else {
				$(".sticky-navbar").removeClass("js-active");
			}
		});

		$(".sticky-navbar--login-register--search-icon--link").click(function (e) {
			e.preventDefault();
			$(".members-block").toggle();
			$(".sticky-navbar--search-container").toggle();
		});
	})(jQuery);

	(function ($) {
		$(".video-meta--title-description__js").click(function () {
			$('.video-meta--content-description').slideDown(300);
			$('.video-meta--content-persons').slideUp(300);
			$(this).addClass('video-meta--title__open');
			$('.video-meta--title-persons__js').removeClass('video-meta--title__open');
		});

		$(".video-meta--title-persons__js").click(function () {
			$('.video-meta--content-description').slideUp(300);
			$('.video-meta--content-persons').slideDown(300);
			$(this).addClass('video-meta--title__open');
			$('.video-meta--title-description__js').removeClass('video-meta--title__open');
		});
		$(".video-meta--content-description").css('height', '135px');
	})(jQuery);

	window.setTimeout(function () {
		var header = $('.header--inner')[0];
		var $win = $(window);
		var articlePage = $('.js body').hasClass('ArticlePage');
		var academyPage = $('.body-courses').hasClass('IaiAcademyCoursesPage');
		$win.scroll(function () {
			if (!$('.auw--img.active').length || $win.scrollTop() > $('.auw--img.active').height()) {
				if (articlePage !== true) {
					$(header).addClass('pos-fixed');
				} else {
					if ($win.scrollTop() == 0) {
						$('.header--inner__dark').addClass('article-header-position');
					} else {
						$('.header--inner__dark').addClass('pos-fixed');
						$('.header--inner__dark').removeClass('article-header-position');
					}
				}
			} else {
				$(header).addClass('pos-relative');
			}
			// Remove fixed position for Academy page while scroll back
			if (academyPage !== true) {
				$(header).addClass('pos-fixed');
			} else {
				if ($win.scrollTop() == 0) {
					$('.header--inner__dark').addClass('pos-relative');
				} else {
					$('.header--inner__dark').addClass('pos-fixed');
				}
			}
		});
	}, 200);

	var $topAdverts = $('.auw-top');
	var $images = $topAdverts.find('.auw--img');
	var $widestImage;
	$images.each(function (idx) {
		if ($(this).width() <= $(window).width()) {
			if (!$widestImage || $widestImage.width() < $(this).width()) {
				$widestImage = $(this);
			}
		}
	});
	if ($widestImage) {
		$widestImage.addClass('active').parent().removeClass('hidden');
	}
	$(window).resize(function () {
		if ($widestImage && $widestImage.width() > $(window).width()) {
			$widestImage = null;
		}
		$images.each(function (idx) {
			if ($(this).width() <= $(window).width()) {
				if (!$widestImage || $widestImage.width() < $(this).width()) {
					$widestImage = $(this);
				}
			}
		});
		if ($widestImage) {
			$widestImage.addClass('active').parent().removeClass('hidden');
		}
	});
	$(".sign-up .article-modal--close").click(function () {
		$(".sign-up").hide();
		$(".sign-up .close-button").hide();
	});
	$(".log-in-btn").click(function (e) {
		var baseUrl = $("#base-url-article").text();
		e.preventDefault();
		e.stopPropagation();
		var url = window.location.href;
		window.location.href = baseUrl + 'sign-in?Prevurl=' + url;
	});
	$(".log-in-span").click(function (e) {
		var baseUrl = $("#base-url-article").text();
		e.preventDefault();
		e.stopPropagation();
		var url = window.location.href;
		window.location.href = baseUrl + 'sign-in?Prevurl=' + url;
	});
	$(".donation-modal--close.close-button").click(function () {
		$(".donation-banners").hide();
		$(".close-button").hide();
	});
	$('.header--mobile-menu__js').on('click', function (e, el) {
		e.preventDefault();
		var $target;
		$target = $('.header--right__js');
		if ($('header').hasClass('full')) {
			$leftNav = $('.full-navbar-signin-wrapper');
			$rightNav = $('.iaie-header__' + window.JS_VARS.pageForRightNav + ' .iaie-header--top-inner');
			$leftNav.toggleClass('moveLeft');
			$rightNav.toggleClass('moveRight');
		} else {
			$leftNav = $('.header--inner__dark');
			$rightNav = $('.common-burger-menu');
			$leftNav.toggleClass('moveLeft');
			$rightNav.toggleClass('moveRight');
		}
		$target.toggleClass('header--right__visible');
		$target = $('.header--left__js');
		$target.toggleClass('header--left__visible');
		$target = $('.iaie-header--top');
		$target.toggleClass('iaie-header--top__visible');
		if ($('body').hasClass('ArticlePage')) {
			$target =  $('.iaie-header__news .iaie-header--inner');
		}
		$target.toggleClass('moveRight');
		$target = $('.iaie-navbar--top-section a.header--sign-in');
		$target.toggle();
	});

	// Sending email for newsletter signup from podcast page
	$(".podcast-signup").click(async function (e) {
		e.preventDefault(); // Prevent the original submit
		var strUrl = window.location.href.split('?')[0] + '/home/getSignupForm';
		var url = strUrl.replace("iai-podcast/", "");
		var email_data = $('#UserEmail').val();
		let shouldSubmitForm = true;
		if (email_data == "") {
			shouldSubmitForm = false;
			$("#error-label").css('display', 'block');
			$("#error-label").html('Email address is required.');
		} else {
			if (!isValidEmailAddress(email_data)) {
				shouldSubmitForm = false;
				$("#error-label").css('display', 'block');
				$("#error-label").html('Enter valid email address.');
			}
		}
		if (shouldSubmitForm) {
			$.ajax({
				url: url,
				data: { "UserEmail": email_data, "RequestType": "HomeSignupBox", "g-recaptcha-response": await createRecaptchaToken() },
				type: "POST",
				success: function (response) {
					if (response == "success") {
						$("#signup-email-form").css('display', 'none');
						$("#submit-label").html('<h3>Check your inbox to confirm subscription</h3>');
					}
				}
			});
		}
	});

	// Sending email for newsletter signup from news/article page
	$(".sign-me").click(async function (e) {
		e.preventDefault(); // Prevent the original submit
		var strUrl = window.location.href.split('?')[0] + '/home/getSignupForm';
		var url = baseHref + '/home/getSignupForm';
		var email_data = $('#UserEmail').val();
		if (email_data == "") {
			$("#error-label").css('display', 'block');
			$("#error-label").html('Email address is required.');
		} else {
			if (!isValidEmailAddress(email_data)) {
				$("#error-label").css('display', 'block');
				$("#error-label").html('Enter valid email address.');
			}
		}
		$.ajax({
			url: url,
			data: { "UserEmail": email_data, "RequestType": "ArticleSignupBox", "g-recaptcha-response": await createRecaptchaToken() },
			type: "POST",
			success: function (response) {
				if (response == "success") {
					$("#signup-email-form").css('display', 'none');
					$("#submit-label").html('<h3>Thank you for signing up to the IAI mailing list!</h3>');
				}
			}
		});
	});

	function isValidEmailAddress (emailAddress) {
		var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
		return pattern.test(emailAddress);
	}
	$(".viewMore").click(function () {
		$(".position-relative .featuredImg").css('display', 'block');
		$('.viewMore').hide();
	});
	$(".viewMoreTwo").click(function () {
		$(".position-relative .secondFeatured").css('display', 'block');
		$('.viewMoreTwo').hide();
	});
	$(".viewMoreThree").click(function () {
		$(".position-relative .thirdFeatured").css('display', 'block');
		$('.viewMoreThree').hide();
	});
	$(".news-link-more__js").click(function () {
		$('.ArticlePage .iaie-header--bottom-inner').toggleClass('news-more');
		$('.SuperCategoryPage .iaie-header--bottom-inner').toggleClass('news-more');
		if ($('.news-link-more__js').html() == 'More') {
			$('.news-link-more__js').html('Less');
		} else {
			$('.news-link-more__js').html('More');
		}
	});
	var is_member_login = $('#MemberID').text();
	var LoggedInUserStringId = $('#LoggedInUserStringId').text();
	if ($("body").hasClass("iai-multilogin")) {
		if (is_member_login > 0) {
			setInterval(function () {
				var baseHref = $('base').attr('href');
				var stringId = LoggedInUserStringId;
				window.localStorage.setItem('userStringId', stringId);
				$.ajax({
					url: baseHref + 'user-logged-in/checkLoggedUser',
					type: "POST",
					data: { userStringId: stringId },
					success: function (response) {
						var resp = JSON.parse(response)
						if (resp.response == false) {
							window.location.href = baseHref + 'other-login';
						}
					}
				});
			}, 900000);
		}
	}
	(function () {
		if ($('.mailchimp-page__popup').length) {
			if (window.location.search.indexOf('account_status=1') >= 0) {
				$('.mailchimp-page__popup-overlay.successful').fadeIn();
			} else if (window.location.search.indexOf('account_status=2') >= 0) {
				$('.mailchimp-page__popup-overlay.already_activated').fadeIn();
			}
		}
		$('.mailchimp-page__popup-button, .mailchimp-page__popup-close').click(function (e) {
			e.preventDefault();
			$('.mailchimp-page__popup-overlay').fadeOut();
		});
	}());
	(function () {
		if ($('.iai-not-logged-in').length) {
			if ($('.iai-rae').length) {
				var accessParam = window.location.href.indexOf('_auid=2020') >= 0;
				if (accessParam) {
					$('.iai-article--wrapper').removeClass('unsubscribed-article-content');
					$('.iai-article--content-inner').removeClass('article-post-content--full');
					$('.iai-article--sidebar').show();
					$('.article-latest-releases__container').show();
					$('.iai-subs__paywall').hide();
					return false;
				}
			}
		}
	}());
	(function ($) {
		$(document).ready(function () {
			$("#OpenChat").click(function () {
				if ($(this).text() == "Open Chat") {
					$("#chatbox").removeClass('htlgi-grid--100').addClass('htlgi-grid--70');
					$(".htlgi-grid--30").show();
					$(this).text("Close Chat");
				} else {
					$("#chatbox").removeClass('htlgi-grid--70').addClass('htlgi-grid--100');
					$(".htlgi-grid--30").hide();
					$(this).text("Open Chat");
				};
			});
		});
	})(jQuery);
	$('.search-link').click(function () {
		$('.advance-search').toggleClass('search-show');
		$(this).toggleClass('link-line');
	});
	$('.ac-list > li.expanded > a').on('click', function (e) {
		e.preventDefault();
		if ($(this).next('ul.ac-sub-menu').is(':visible')) {
			$(this).removeClass('open');
			$(this).next('ul.ac-sub-menu').slideUp();
		} else {
			$('.ac-list > li.expanded > a').removeClass('open');
			$(this).addClass('open');
			$('.ac-list > li.expanded > a').next('ul.ac-sub-menu').slideUp();
			$(this).next('ul.ac-sub-menu').slideToggle();
		}
	});
	$('.dropdown-filter__select').each(function () {
		var $this = $(this), numberOfOptions = $(this).children('option').length;
		$this.addClass('select-hidden');
		$this.wrap('<div class="select"></div>');
		$this.after('<div class="select-styled"></div>');
		var $styledSelect = $this.next('div.select-styled');
		$styledSelect.text($this.children('option:selected').text());
		var $list = $('<ul />', {
			'class': 'select-options'
		}).insertAfter($styledSelect);
		for (var i = 0; i < numberOfOptions; i++) {
			if (typeof $this.children('option').eq(i).attr('data-value') == "undefined") {
				var data_value = $this.children('option').eq(i).text();
			} else {
				var data_value = $this.children('option').eq(i).text() + "<span>" + $this.children('option').eq(i).attr('data-value') + "</span>";
			}
			$('<li />', {
				html: data_value,
				rel: $this.children('option').eq(i).val()
			}).appendTo($list);
		}

		var $listItems = $list.children('li');
		$styledSelect.click(function (e) {
			e.stopPropagation();
			$('div.select-styled.active').not(this).each(function () {
				$(this).removeClass('active').next('ul.select-options').hide();
			});
			$(this).toggleClass('active').next('ul.select-options').toggle();
		});

		$listItems.click(function (e) {
			e.stopPropagation();
			$styledSelect.text($($(this).contents().get(0)).text()).removeClass('active');
			$this.val($(this).attr('rel'));
			$this.trigger('change');
			$list.hide();
		});
		$(document).click(function () {
			$styledSelect.removeClass('active');
			$list.hide();
		});
	});

	// Custom Dropdown End
	$('#setArticleInStorage').click(function () {
		sessionStorage.setItem('ArticleUrl', window.location.href);
	});

	// Article channel page filtration starts
	$(document).on('change', '[name="channel"], [name="sort"]', function (e, el) {
		e.preventDefault();
		let channel = $('[name="channel"]').val();
		let sort = $('[name="sort"]').val();
		return searchResultFilter(search = null, channel, sort, page = null);
	});

	$(document).on('click', '.searchResultPagination', function (e) {
		e.preventDefault();
		let channel = $('[name="channel"]').val();
		let sort = $('[name="sort"]').val();
		let search = $('[name="search"]').val();
		let page = $(this).attr('data-id');
		return searchResultFilter(search, channel, sort, page);
	});

	$(document).on('click', '.article-channel--search-button', function (e, el) {
		e.preventDefault();
		let search = $('[name="search"]').val();
		return searchResultFilter(search, channel = null, sort = null, page = null);
	});

	function searchResultFilter (search, channel, sort, page) {
		let url = baseHref + "article-channel/fetch";
		let returnArr = '';
		$.ajax({
			url: url,
			data: { "search": search, "channel": channel, "sort": sort, "page": page },
			type: "POST",
			success: function (response) {
				var parseData = JSON.parse(response);
				$('.article-channel--results-list').html("");
				if (parseData.Articles) {
					$('.iai-article-channel-content-wrapper').hide();
					returnArr = returnArr + '<div class="article-channel--results"><ul class="article-channel--results-list">';
					$(parseData.Articles).each(function (index, value) {
						returnArr = returnArr + '<li class="article-channel--result article-channel--result__js">';
						returnArr += '<a class="article-channel-isc" href="' + baseHref + 'articles/' + value.Link + '">';
						returnArr += '<div class="article-channel-isc--image">';
						returnArr += '<div class="widget-dummy"></div>';
						returnArr += '<img src="/' + value.Image + '" class="widget-image" alt=""></div>';
						returnArr += '<div class="article-channel-isc--meta"><div class="article-channel-isc--meta-inner">';
						returnArr += '<div class="article-channel-isc--speakers">';
						returnArr += '<span class="article-channel-isc--speaker">' + value.Person + '</span>.</div>';
						returnArr += '<h2 class="article-channel-isc--title">' + value.Title + '</h2>';
						returnArr += '<h3 class="article-channel-isc--subtitle">' + value.Subtitle + '</h3></div>';
						returnArr += '<div class="article-channel-isc--posted">Posted ' + value.DateAdded + '</div>';
						returnArr += '</div></a></li></a></li>';
						$('.article-channel--results-list').html(returnArr);
					});
					returnArr = returnArr + '</ul></div>';
				}

				$('.search-result').replaceWith(returnArr);
				if (parseData.HighestPage > 0) {
					let returnHtml = '';
					for (let i = 0; i <= parseData.HighestPage; i++) {
						let pageNumber = i + 1;
						returnHtml += '<a href="javascript:void(0)" data-id="' + i + '" class="searchResultPagination page' + i + '" >' + pageNumber + '</a>';
					}
					$('.search-result-pagination').html(returnHtml);
					$('.search-result-pagination a').removeClass('active');
					$('.page' + page).addClass('active');
					$('.search-result-pagination').show();
				} else {
					$('.search-result-pagination').html('');
				}
			}
		});
		$('.article-channel--loader__js').bind('ajaxStart', function () {
			$('.article-channel--loader__js').show();
		}).bind('ajaxStop', function () {
			$('.article-channel--loader__js').hide();
		});
	}
	// Article channel page filtration ends

	// Support Us Page Secondary Navbar Start
	$document.on('click', '.iaie-mobile-secondary-menu', function (e) {
		e.preventDefault();
		$('nav').toggleClass('support-secondary-menu-height');
		if ($('.iaie-mobile-secondary-menu').html() == 'Less') {
			$('.iaie-mobile-secondary-menu').html('More');
		} else {
			$('.iaie-mobile-secondary-menu').html('Less');
		}
	});

	function showMore () {
		var menu_width = $('.iaie-header--menu--bottom').width();
		var more_width = $('.iaie-link').width();
		var window_width = $(window).width();
		if ($(window).width() <= "580") {
			$('.iaie-link').removeClass('secondary-menu--more__hidden');
		} else {
			$('.iaie-link').addClass('secondary-menu--more__hidden');
		}
	}
	showMore();
	$(window).resize(showMore);
	// Support Us Page Secondary Navbar End

	// Start :: Iai Education Page JS
	$(document).ready(function () {
		$(".success-pop-up-content").hide();
	});
	$(".primary-video").click(function () {
		$('.video_js').attr('controls', true);
		$('.primary-video img').css('display', 'none');
	});
	$(".speaker-description").click(function () {
		let id = $(this).attr('data-id');
		let url = baseHref + 'IaiEducationPage_Controller/getSpeakerDetails';
		$.ajax({
			url: url,
			data: { "ID": id },
			type: "POST",
			success: function (output) {
				var response = JSON.parse(output);
				$(".custom-model-main").addClass('model-open');
				$(".pop-up-content-wrap").html(response.speakerDescription);
				$('.speaker-image').html('<img src="' + response.speakerImage + '" />');
			}
		});
	});
	$(".education-form").click(function () {
		$(".educationform-main").addClass('model-open');
	});
	$(".close-btn").click(function () {
		$(".custom-model-main").removeClass('model-open');
	});
	$(".education-form-close-btn").click(function () {
		$(".educationform-main").removeClass('model-open');
	});
	$(".btn-education").click(function (e) {
		e.preventDefault();
		$('#lblUserNameError').empty();
		$('#lblOrganisationNameError').empty();
		$('#lblUserEmailError').empty();
		var name = $('#UserName').val();
		var organisation = $('#OrganisationName').val();
		var email = $('#UserEmail').val();
		var phone = $('#UserPhone').val();
		var message = $('#UserMessage').val();
		var url = baseHref + 'IaiEducationPage_Controller/getIaiEducationForm';
		if (!name) {
			$('#lblUserNameError').html("Please Enter Name");
			return false;
		} else if (!organisation) {
			$('#lblOrganisationNameError').html("Please Enter Organisation Name");
			return false;
		} else if (!email) {
			$('#lblUserEmailError').html("Please Enter Email");
			return false;
		} else if (!isValidEmailAddress(email)) {
			$('#lblUserEmailError').html("Please enter valid email address.");
			return false;
		}
		$.ajax({
			url: url,
			data: { "UserName": name, "OrganisationName": organisation, "UserEmail": email, "Contactnumber": phone, "UserMessage": message, "RequestType": "EducationForm" },
			type: "POST",
			success: function (response) {
				if (response == 'success') {
					$(".pop-up-content").hide();
					$(".success-pop-up-content").show();
				}
			}
		})
	});
	$('.email-library-popup').click(function () {
		$('.email-library-model').removeClass('hidden');
	});
	$('.email-library-close-btn').click(function () {
		$('.email-library-model').addClass('hidden');
	});
	$('.library-copy-text').click(function () {
		let textToCopy = document.getElementById('email-library').innerText;
		if (navigator.clipboard) {
			navigator.clipboard.writeText(textToCopy).then(() => {
				$('.copy-to-clipboard-success--js').html('Copied to clipboard');
			})
		}
		$('.copy-to-clipboard-success--js').removeClass('hidden');
		setTimeout(function () {
			$('.copy-to-clipboard-success--js').empty();
			$('.copy-to-clipboard-success--js').addClass('hidden');
		}, 1500);
	});
	// End :: Iai Education Page JS

	// Start : Article citation JS
	const CITATION_COPY_SUCCESS_MESSAGE = "Citation copied to clipboard";
	const CITATION_COPY_FAIL_MESSAGE = "Copy not supported or blocked";
	$(document).on('click', '.article-citation-popup--js', function () {
		$('.citation-popup').removeClass('hidden');
	});
	$(document).on('click', '.popup-close', function () {
		$('.citation-popup').addClass('hidden');
	});
	$(document).on('click', '#articleApaTextBtn--js', function () {
		copyToClipboard('apaCitationText');
	});
	$(document).on('click', '#articleMlaTextBtn--js', function () {
		copyToClipboard('mlaCitationText');
	});
	function copyToClipboard (element) {
		let textToCopy = document.getElementById(element).innerText;
		if (navigator.clipboard) {
			navigator.clipboard.writeText(textToCopy).then(() => {
				$('.copy-to-clipboard-success--js').html(CITATION_COPY_SUCCESS_MESSAGE);
			})
		} else {
			$('.copy-to-clipboard-success--js').html(CITATION_COPY_FAIL_MESSAGE);
		}
		$('.copy-success-div--js').removeClass('hidden');
		setTimeout(function () {
			$('.copy-to-clipboard-success--js').empty();
			$('.copy-success-div--js').addClass('hidden');
		}, 1500);
	}
	// End : Article citation JS

	// Start : Newsletter submit JS
	function submitSignupFormWithRecaptchaToken(token) {
		var baseHref = $("base").first().attr("href");
		var url = baseHref + 'Page_Controller/getSignupForm';
		var email_data = $('.footer--signup #SignUpForm_getSignupForm_UserEmail').val();
		if (email_data == "") {
			$("#error-label").css('display', 'block');
			$("#error-label").html('Email address is required.');
			return;
		} else {
			if (!isValidEmailAddress(email_data)) {
				$("#error-label").css('display', 'block');
				$("#error-label").html('Enter valid email address.');
				return;
			}
		}

		$.ajax({
			url: url,
			data: {
				"UserEmail": email_data,
				"g-recaptcha-response": token,
				"RequestType": "HomeSignBox",
				"Source": $(".footer--signup #SignUpForm_getSignupForm_Source").val()
			},
			type: "POST",
			success: function(response) {
				if (response == "success") {
					$(".footer--signup--title").html("<h3>You&apos;re signed up.</h3>");
					$("#signup-email-form, .landing-header-text, #error-label").css('display', 'none');
					$(".success-header-text").css('display', 'block');
					$(".submit-label").css('display', 'inline-block');
					$(".footer--light, #SignUpForm_getSignupForm_UserEmail_Holder, button.action.rounded-button-blue").css('display', 'none');
					$("#SignUpForm_getSignupForm_error").addClass('show').html('<span>Thank you for subscribing to our mailing list.</span>');
				}
			}
		});
	}

	$(document).on("submit", ".footer--signup #SignUpForm_getSignupForm", function(e) {
		e.preventDefault();
	
		grecaptcha.ready(function() {
			grecaptcha.execute(window.JS_VARS.recaptchaV3SiteKey, { action: 'signup' }).then(function(token) {
				submitSignupFormWithRecaptchaToken(token);
			}).catch(function(error){
				$('.footer--signup #SignUpForm_getSignupForm').css({'display': 'block', 'color': 'red'});
				$('#SignUpForm_getSignupForm_error').html("Recaptcha verification failed.");
			});
		});
	});
	// END : Newsletter submit JS

	$(document).on("submit", ".news-letter-sign-up #SignUpForm_getSignupForm", function (e) {
		e.preventDefault();
		let shouldSubmitForm = true;
		const captchResponse = grecaptcha.getResponse();
		if(captchResponse.length == 0) {
			$('.footer--signup #SignUpForm_getSignupForm').css({'display': 'block', 'color': 'red'});
			$('SignUpForm_getSignupForm_error').innerHTML="You can't leave Captcha Code empty";
			return false;
		}
		const userEmail = $('.news-letter-sign-up #SignUpForm_getSignupForm_UserEmail').val();
		if(!userEmail) {
			shouldSubmitForm = false;
			$("#error-label").removeClass('hidden');
			$("#error-label").html('Email address is required.');
		} else {
			if(!isValidEmailAddress(userEmail)) {
				shouldSubmitForm = false;
				$("#error-label").removeClass('hidden');
				$("#error-label").html('Please enter valid email address.');
			}
		}
		if (shouldSubmitForm) {
			$.ajax({
				url: baseHref + 'Page_Controller/getSignupForm',
				data: {
					"UserEmail": userEmail,
					"g-recaptcha-response" : $(".news-letter-sign-up .g-recaptcha-response").val(),
					"RequestType" : "LiveSignupBox","Source" : "IAI LIVE Evening Page"
				},
				type: "POST",
				success:function (response) {
					if(response == "success") {
						$('.news-letter-sign-up #SignUpForm_getSignupForm')[0].reset();
						$("#signup-email-form, .landing-header-text, #error-label").addClass('hidden');
						$(".success-header-text, .submit-label").removeClass('hidden');
						$("#SignUpForm_getSignupForm_error").addClass('show').html('<span>Thank you for subscribing to our mailing list.</span>');
						grecaptcha.reset();
					}
				}
			});
		}
	});

	// START : Article Popup JS
	(function ($) {
		$(".article--popup-close, .article--popup-button2").click(function () {
			$(".article--popup").addClass('hidden');
		});
	})(jQuery);
	// END : Article Popup JS
});